import { FC } from 'react';
import { format as formatDate } from 'date-fns';
import Checks from '@components/Icons/Checks';
import classNames from 'classnames';
import UserImage from '@components/UserImage';
import UserWorkflowInfo from '@components/UserWorkflowInfo';
import { m } from 'framer-motion';
import Buttons from '@components/Buttons';
import classes from './UserWorkflowCard.module.scss';

type UserWorkflowCardProps = {
  userWorkflow:
    & {
      createdAt: string;
      id: string;
      person: {
        image?: { url: string } | null;
        name: string | null;
        primaryColour: { hex: string } | null;
      }
    }
    & Parameters<typeof UserWorkflowInfo>[0]['userWorkflow'];
  hasAssignedTasks: boolean | 'fetching';
  isCreatorView: boolean;
  isRouting: boolean;
  onClick: (userWorkflowId: string) => void;
};

const MotionButton = m(Buttons);

const UserWorkflowCard: FC<UserWorkflowCardProps> = ({ onClick, isCreatorView, isRouting, userWorkflow, hasAssignedTasks }) => {
  const isAssigned = hasAssignedTasks !== 'fetching' && hasAssignedTasks;
  return (
    <MotionButton
      isWrapper
      className={classNames(classes.userWorkflowContainer, isCreatorView ? null : classes.userWorkflowContainer_isUserView)}
      onClick={() => onClick(userWorkflow.id)}
      whileHover={{ zIndex: 1 }}
      style={isAssigned ? { border: '4px solid var(--color-warning)', borderRadius: 16 } : undefined}
      isShimmering={isRouting}
    >
      {isAssigned && (
        <div
          className={classes.lastActivity}
          style={isAssigned ? { backgroundColor: 'var(--color-warning)', color: 'var(--color-gray-0)', paddingBottom: 3 } : undefined}
        >
          <div className={classes.assignments}>
            <Checks weight="fill" size="16" />
            <small>
              <b>Tasks to complete</b>
            </small>
          </div>
        </div>
      )}
      {!isCreatorView && <div className={classes.open} {...isAssigned && {
        style: {
          top: 36,
        },
      }}>Open</div>}
      <div style={(isCreatorView && { padding: 8 }) || undefined}>
        {isCreatorView && (
          <div className={classes.userInfo}>
            <UserImage
              url={userWorkflow.person.image?.url}
              name={userWorkflow.person.name}
              color={userWorkflow.person.primaryColour?.hex}
              size={36}
            />
            <div className={classes.userInfo_text}>
              <p className="body-sm-bold">{userWorkflow.person.name}</p>
              <p className="caption">{`Started on ${formatDate(new Date(userWorkflow.createdAt), 'MMM do, hh:mm a')}`}</p>
            </div>
            <div className={classes.caret}>
                View
            </div>
          </div>
        )}
        <UserWorkflowInfo
          creator={null}
          compiledDocuments={null}
          userWorkflow={userWorkflow}
          hasBorder={isCreatorView}
          workflowSteps={[]}
          isCreatorView={isCreatorView}
          isCard
        />
      </div>
    </MotionButton>
  );
};

export default UserWorkflowCard;
